import { combineReducers } from "redux";
import NotificationReducer from "./reducers/notificationForWebsite/reducer";
import E_TENDER_NotificationReducer from "./reducers/Etender/reducer";
import WEBSITE_NOTIFICATIONS_NotificationReducer from "./reducers/WebsiteNotification/reducer";
import RegistrationReducer from "./reducers/Registration/reducer";
import CalanderReducer from "./reducers/CalanderEvents/reducer";
import { ALL_SCHEMES_LISTreducer } from "./reducers/Scheme/reducer";
import { ALL_VIDEO_LISTreducer } from "./reducers/LatestVideoes/reducer";
import { ALL_NEWS_LISTreducer } from "./reducers/LatestNews/reducer";
import { ALL_INSITUTION_LISTreducer } from "./reducers/InsititutionRegistration/reducer";
import { VenueReducer } from "./reducers/Booking/reducer";

import { BookingReducer } from "./reducers/Booking/reducer";
const rootReducer = combineReducers({
  NotificationReducer,
  E_TENDER_NotificationReducer,
  WEBSITE_NOTIFICATIONS_NotificationReducer,
  RegistrationReducer,
  ALL_VIDEO_LISTreducer,
  ALL_NEWS_LISTreducer,
  ALL_INSITUTION_LISTreducer,
  CalanderReducer,
  VenueReducer,
  BookingReducer,
  ALL_SCHEMES_LISTreducer,
  
});
export default rootReducer;
